<template>
  <div class="home">
    <Loading :loading="loading" />
    <Canvas :src="pdfFile" v-on:loadingFun="closeLoading" />
  </div>
</template>

<script>
import Canvas from './canvas';
import Loading from './Loading';
export default {
  name: 'home',
    components:{
    Canvas,
    Loading
  },
  data(){
    return {
      // pdfFile:'https://fanhuayiju.oss-cn-beijing.aliyuncs.com/1556176664000%E8%AE%A2%E5%8D%95%E4%B8%9A%E5%8A%A1%E6%A2%B3%E7%90%86_V1.4.pdf',
      pdfFile:'',
      loading:true,
      imgSrc: ''
    }
  },
  created(){
    this.pdfFile = `https://fanhuayiju.oss-cn-beijing.aliyuncs.com/${this.$route.query.item.contractFileName}`;
    console.log(this.pdfFile)
  },
  methods: {
    closeLoading:function(val){
      this.loading = val;
    }
  }
}
</script>
<style scoped>
.pdfs{
  width: 100vw !important;
}
</style>
